import { getCurrentInstance } from "vue";

export const useApi = () => {
  const app = getCurrentInstance();

  if (app) {
    return app.proxy.$root.$http;
  }
};
